export default __webpack_public_path__ + "static/damper_b.32a394d5f4be63f97e29f4039467ba54.svg";